import type { ReactNode } from 'react';

export type TUserRole = 'super_admin' | 'tenant_admin' | 'operator' | 'viewer';

export interface IUnidadeBrief {
  id: string;
  nome: string;
  sif: string;
}

export interface IUser {
  id: string;
  email: string;
  nome?: string;
  role: TUserRole;
  tenant_id: string | null;
  unidades_visiveis: IUnidadeBrief[];
}

export interface ILoginCredentials {
  email: string;
  senha: string;
}

export interface ILoginResponse {
  access_token: string;
  refresh_token: string;
  token_type: string;
}

export interface IUsuarioMeResponse {
  id: string;
  email: string;
  nome: string;
  role: TUserRole;
  tenant_id: string | null;
  unidades_visiveis: IUnidadeBrief[];
}

export interface IAuthErrorResponse {
  error: string;
}

export type TAuthHeaders = {
  'Content-Type': 'application/json';
  Authorization?: string;
  'X-Tenant-Id'?: string;
};

export interface IAuthContextValue {
  user: IUser | null;
  loading: boolean;
  accessToken: string | null;
  /** Tenant efetivo (personificação). Só relevante para super_admin. */
  effectiveTenantId: string | null;
  login: (email: string, senha: string) => Promise<boolean>;
  logout: () => Promise<void>;
  setEffectiveTenantId: (tenantId: string | null) => void;
  getAuthHeaders: () => TAuthHeaders;
}

export interface IAuthProviderProps {
  children: ReactNode;
}

export const AUTH_STORAGE_KEYS = {
  accessToken: 'access_token',
  refreshToken: 'refresh_token',
  userData: 'user_data',
  effectiveTenantId: 'effective_tenant_id',
} as const;

export const AUTH_UNAUTHORIZED_EVENT = 'auth:unauthorized';

export const SUPER_ADMIN_ROLE: TUserRole = 'super_admin';
